import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import {
  CONSTANTS,
  COOKIE,
  SOCIAL_PERPAGE_LIMIT,
  VERTICALS,
} from "../../../../constants/app-constant";
import { httpGet, httpPost } from "../../../../utility/requestHelper";
import { groupBy, initials } from "../../../../utility/common-methods";
import { Button } from "../../../Shared/FormElements/Button";
import SocialFilters from "../../Filters/SocialFilter";
import {
  getDateFormat,
  getUniqueValuesFromList,
  filterListFromAnotherList,
  formatDate,
} from "../../../../utility/common-methods.jsx";
import { unifiedEnvConfig } from "../../../../constants/api-endpoint";
import { FEED_DETAILS } from "../../../../constants/route-constants";
import DateRangeFilter from "../../Filters/DateRangeFilter";
import {
  FilterIcon,
  PlusIcon,
  MenuIcon,
  DownLoadSuccess,
} from "../../../Icons/icons.component.jsx";
import ArticleTags from "../ArticleTags";
import DownloadFeeds from "../DownloadFeeds";
import { useSelector } from "react-redux";
import TopicWiseNewsContainer from "../PrintAndOnline/TopicWiseNewsContainer";
import Loader from "../../../Shared/Loader";
import NoDataMessage from "../../../Shared/NoDataMessage";
import "../../Analysis/print.sass";
import ConceptLogo from "../../../../assets/images/conceptbiu-logo.png";
import {
  SOCIAL_SOURCES_OPTIONS,
  SOCIAL_TONALITY_FILTER,
} from "../../../../constants/static-filter";
import { TagsListModal } from "../../TagsAndFavourites/Tags/TagsListModal";
import SocialDownload from "../../../Shared/SocialDownload";
import { getCookie, setCookie } from "../../../../utility/cookieProvider";
import styles from "../../Download.module.css";
import DownloadPopup from "../../DownloadPopup";
import GifLoader from "../../../Shared/LoaderGif";
import { feedCountInArray } from "./utils/feedCountInArray";

const { DATA_NOT_FOUND, EMPTY_ARRAY, EMPTY_OBJECT, EMPTY_STRING } = CONSTANTS;

const { V_BLOG, V_FORUM } = VERTICALS;
const today = new Date();
const previousWeekDay = new Date().setDate(today.getDate() - 6);
const defaultValues = {
  def_fromDate: getDateFormat(today),
  def_toDate: getDateFormat(today),
  def_channelType: EMPTY_ARRAY,
  def_comments_count: 0,
  def_reaction_count: 0,
  def_city: EMPTY_STRING,
  def_tonality: EMPTY_ARRAY,
};

const {
  def_toDate,
  def_fromDate,
  def_reaction_count,
  def_tonality,
  def_channelType,
  def_city,
  def_comments_count,
} = defaultValues;

function BlogsAndForum({ data }) {
  const listContainerRef = useRef(null);
  const [limit, setLimit] = useState(1);
  const [totalFeedCount, setTotalFeedCount] = useState(null);
  const [blogsAndForumsFeedList, setBlogsAndForumsFeedList] =
    useState(EMPTY_ARRAY);
  const [hideShowMore, setHideShowMore] = useState(false);
  const [blogsAndForumsTopicData, setBlogsAndForumsTopicData] = useState({
    pagination: {
      pages: 1,
      data: EMPTY_ARRAY,
      total: 0,
    },
  });

  const [fromDate, setFromDate] = useState(def_fromDate);
  const [toDate, setToDate] = useState(def_toDate);
  const [channelType, setChannelType] = useState(
    SOCIAL_SOURCES_OPTIONS.map(({ id }) => id)
  );
  const [comments, setComments] = useState(def_comments_count);
  const [city, setCity] = useState(EMPTY_OBJECT);
  const [showImgViewer, setShowImgViewer] = useState(false);
  const [firstImageToShow, setFirstImageToShow] = useState(0);
  const [imgSrcArray, setImageSrcArray] = useState(EMPTY_ARRAY);
  const [selectCity, setSelectedCity] = useState(def_city);
  const [reaction, setReaction] = useState(def_reaction_count);
  const [tonality, setTonality] = useState(def_tonality);
  const [isLoading, setIsLoading] = useState(true);
  const [feedDetail, setFeedDetails] = useState(EMPTY_STRING);
  const [detailsFeed, setDetailsFeed] = useState(false);
  const [scrollValues, setScrollValues] = useState(EMPTY_ARRAY);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [activeKey, setActiveKey] = useState(-1);
  const [selectedFeeds, setSelectedFeeds] = useState([]);
  const [selectedFeedsGroup, setSelectedFeedsGroup] = useState([]);
  const [updatedBulkSentiment, setUpdatedBulkSentiment] = useState("");
  const [updatedBulkFavourite, setUpdatedBulkFavourite] = useState(false);
  const [showAddTagListModal, setShowAddTagListModal] = useState(false);
  const [isFavouriteChecked, setIsFavouriteChecked] = useState(false);
  const [vertical, setVertical] = useState("");
  const [hasDataInit, setHasDataInit] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [selectedType, setSelectedType] = useState(undefined);
  const [selectedTaglist, setSelectedTaglist] = useState([]);
  const [tagListData, setTagListData] = useState([]);
  const isSocialDownloading = getCookie(COOKIE.IS_SOCIAL_DOWNLOADING);
  const isPrintDownloading = getCookie(COOKIE.IS_PRINT_DOWNLOADING);
  const isBlogDownloading = getCookie(COOKIE.IS_BLOG_DOWNLOADING);
  const [showList, setShowList] = useState(true);
  const DownloadSuccess = getCookie(COOKIE.DOWNLOAD_SUCCESS);
  const [popup, setPopup] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [headline, setHeadline] = useState("");
  const [keyword, setKeyword] = useState("");

  // const [tagsApplied, setTagsApplied]= useState(false)

  const entityState = useSelector(
    (state) => state.entityAndKeyWordsReducer || {}
  );
  const { socialEntityList } = entityState || [];
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  const clientState = useSelector((state) => state.clientReducer) || {};
  const parentClientId = useSelector(
    (state) => state.entityAndKeyWordsReducer.parentClientId
  );
  const { feedTagList } = clientState;

  // useEffect(() => {
  //   fetchCity();
  // }, EMPTY_ARRAY);

  useEffect(() => {
    if (selectedTopics && selectedTopics.length && !hasDataInit) {
      fetchBlogsAndForumsFeedsFilterData(false);
      setHasDataInit(true);
    }
  }, [selectedTopics.length]);

  useEffect(() => {
    fetchBlogsAndForumsFeedsFilterData(limit !== 1);
  }, [limit, fromDate, toDate]);
  useEffect(() => {
    if (feedTagList) {
      const { data } = feedTagList;
      data.forEach((item, i) => {
        if (item.name === "Not Rated") {
          data.splice(i, 1);
          data.unshift(item);
        }
      });
      // const tagIds = data.map((e) => e.name);
      // setSelectedTaglist(tagIds);
      setTagListData(data);
    }
  }, [feedTagList]);

  useEffect(() => {
    if (
      blogsAndForumsTopicData &&
      blogsAndForumsTopicData.pagination &&
      blogsAndForumsTopicData.pagination.total
    ) {
      setHideShowMore(
        blogsAndForumsTopicData.pagination.total ===
          blogsAndForumsFeedList.length
      );
    }
  }, [blogsAndForumsFeedList]);

  useEffect(() => {
    if (DownloadSuccess === "true") {
      setPopup(DownloadSuccess === "true");
    }
    setTimeout(() => {
      setCookie({
        key: COOKIE.DOWNLOAD_SUCCESS,
        value: false,
      });
      setPopup(false);
    }, 5000);
  }, [DownloadSuccess]);

  useEffect(() => {
    if (socialEntityList) {
      const entIdList = socialEntityList.map((e) => e && e.id);
      setSelectedTopics(entIdList);
    }
  }, [socialEntityList]);

  useEffect(() => {
    if (updatedBulkSentiment) {
      setTimeout(() => {
        setSelectedFeeds([]);
        setSelectedFeedsGroup([]);
      }, 100);
    }
  }, [updatedBulkSentiment]);

  useEffect(() => {
    setSelectedFeeds([]);
    setSelectedFeedsGroup([]);
  }, [updatedBulkFavourite]);

  const handleMoreClick = () => {
    if (data) {
      setLimit(limit + 1);
    }
  };

  const handleResetAll = () => {
    setSelectedCity(def_city);
    setReaction(def_reaction_count);
    setComments(def_comments_count);
    setTonality(def_tonality);
    setToDate(def_toDate);
    setFromDate(def_fromDate);
    setChannelType(def_channelType);
    setSelectedTopics([]);
    setIsFavouriteChecked(false);
    setVertical("");
    // setTagsApplied(false)
  };

  const fetchCity = () => {
    const topicId = data ? data.id : "";

    httpGet(
      `${unifiedEnvConfig.FETCH_CITY}?searchParams[topic_id]=${topicId}&client_id=${selectedClient.id}`
    )
      .then((response) => {
        if (response.data) {
          setCity(response.data);
        }
      })
      .catch((e) => e);
  };

  const getFeedSearchUrl = (
    selectedTopicIds = [],
    vType = V_BLOG,
    urlType = ""
  ) => {
    const sDate = fromDate;
    const eDate = toDate;
    const topicId = selectedTopics;
    let client_id = selectedClient && selectedClient.id;

    let url = "";
    switch (urlType) {
      case "favourite":
        url = unifiedEnvConfig.UPDATE_FAVOURITES_TAG;
        break;
      case "sentiment":
        url = unifiedEnvConfig.SOCIAL_UPDATE_SENTIMENTS;
        break;
      case "tags":
        url = unifiedEnvConfig.ADD_TAG_TO_FEED;
        break;
      case "download":
        url = unifiedEnvConfig.FEEDS_DOWNLOAD;
        break;
      case "olddownload":
        url = unifiedEnvConfig.FETCH_SOCIAL_FEEDS;
        break;
      default:
        url = unifiedEnvConfig.FETCH_SOCIAL_FEEDS_COUNT;
        if (parentClientId !== selectedClient.id) {
          client_id = parentClientId;
        }
        break;
    }

    let tempUrl = `${url}?client_id=${client_id}&page=${limit}&perPage=${SOCIAL_PERPAGE_LIMIT}&searchParams[from_date]=${sDate}&searchParams[to_date]=${eDate}`;
    if (vType == V_BLOG) {
      tempUrl = `${tempUrl}&searchParams[type][]=${V_BLOG}`;
    }
    if (vType == V_FORUM) {
      tempUrl = `${tempUrl}&searchParams[type][]=${V_FORUM}`;
    }
    if (isFavouriteChecked) {
      tempUrl = `${tempUrl}&favFilter=${isFavouriteChecked}`;
    }
    if (tonality && tonality.length) {
      tempUrl = `${tempUrl}&tonalityFilter[]=${tonality}`;
    }
    if (selectCity && selectCity.length) {
      tempUrl = `${tempUrl}&searchParams[city]=${selectCity}`;
    }
    if (comments && comments.length) {
      tempUrl = `${tempUrl}&searchParams[min_comments]=${comments}`;
    }
    if (reaction && reaction.length) {
      tempUrl = `${tempUrl}&searchParams[min_reactions]=${reaction}`;
    }
    if (selectedTaglist && selectedTaglist.length) {
      selectedTaglist.forEach((t) => {
        tempUrl = `${tempUrl}&tagFilter[]=${t === "Not Rated" ? null : t}`;
      });
    }
    if (headline) {
      tempUrl = `${tempUrl}&headlineFilter=${headline}`;
    }
    if (keyword) {
      tempUrl = `${tempUrl}&keywordFilter=${keyword}`;
    }
    if (urlType !== "download") {
      if (selectedTopicIds.length > 0) {
        [...new Set(selectedTopicIds)].forEach((t) => {
          tempUrl = `${tempUrl}${
            !urlType ? "&searchParams[topic_ids][]" : "&searchParams[topic_id]"
          }=${t}`;
        });
      } else {
        topicId.forEach((t) => {
          tempUrl = `${tempUrl}&searchParams[topic_ids][]=${t}`;
        });
      }
    } else {
      if (selectedFeeds && selectedFeeds.some((elm) => elm.type == V_FORUM))
        tempUrl = `${tempUrl}&searchParams[type][]=${V_FORUM}`;
      if (selectedFeeds && selectedFeeds.some((elm) => elm.type == V_BLOG))
        tempUrl = `${tempUrl}&searchParams[type][]=${V_BLOG}`;
    }
    return tempUrl;
  };

  const fetchBlogsAndForumsFeedsFilterData = (preserveData) => {
    if (selectedTopics.length) {
      setIsLoading(true);
      Promise.all(getApiCall())
        .then((d) => {
          if (!d) return;
          let combinedFeeds = [];
          let groupedData = {};
          let [bData, fData] = [
            (d[0] && d[0].data && d[0].data.data.topics) || [],
            (d[1] && d[1].data && d[1].data.data.topics) || [],
          ];

          let i = 0,
            j = 0;
          let tempData = [];
          for (i = 0, j = 0; i < bData.length || j < fData.length; i++, j++) {
            if (bData[i]) {
              bData[i]["type"] = vertical === 6 ? 6 : 5;
              bData[i] && tempData.push(bData[i]);
            }
            if (fData[j]) {
              fData[j]["type"] = vertical === "" ? 6 : 5;
              fData[j] && tempData.push(fData[j]);
            }
          }
          combinedFeeds = tempData;
          groupedData = {
            ...d[0],
            data: { ...d[0].data, data: combinedFeeds },
          };
          if (groupedData) {
            setBlogsAndForumsTopicData(groupedData);
            let allFeeds = [...groupedData.data.data];
            allFeeds = allFeeds.filter((elm) => elm.count !== 0 && elm);
            // if (preserveData) {
            //   allFeeds = [...blogsAndForumsFeedList, allFeeds].flat();
            // }
            let totalCount = d[0]
              ? feedCountInArray(d[0].data.data.topics, selectedTopics)
              : 0 + d[1]
              ? feedCountInArray(d[1].data.data.topics, selectedTopics)
              : 0;
            setTotalFeedCount(totalCount);
            // if (allFeeds && allFeeds.length) {
            //   setTotalFeedCount(
            //     (prevVal) =>
            //       allFeeds.reduce(
            //         (prevEle, currentEle) => ({
            //           total: prevEle.total + currentEle.total,
            //         }),
            //         { total: 0 }
            //       ).total
            //   );
            // }

            //if client is child of another client filter the blogsandforumsfeedlist
            // let feedsToDisplay = allFeeds;
            // const currClientId = (selectedClient) ? selectedClient.id : null;
            // if (currClientId !== parentEntityId)
            const feedsToDisplay = allFeeds.filter((val) =>
              selectedTopics.includes(val.topic.id)
            );
            setBlogsAndForumsFeedList(feedsToDisplay);
            // eslint-disable-next-line
            if (limit == 1) {
              window.scrollTo(0, 0);
            }
          }
        })
        .catch((e) => {
          console.log("[Error in Social feeds search]: ", e);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const getApiCall = (data) => {
    let requestQueue = [];
    if (!vertical || vertical == V_BLOG) {
      requestQueue.push(httpGet(getFeedSearchUrl([], V_BLOG)));
    }
    if (!vertical || vertical == V_FORUM) {
      requestQueue.push(httpGet(getFeedSearchUrl([], V_FORUM)));
    }
    return requestQueue;
  };

  function onFilterApply(customParams) {
    // setTagsApplied(true)
    // TODO: should be handled in better way.
    // Resetting limit state to trigger useEffect.
    if (customParams) {
      setToDate(customParams.endDate);
      setFromDate(customParams.startDate);
    } else {
      fetchBlogsAndForumsFeedsFilterData(false);
    }
    setSelectedFeedsGroup([]);
    setSelectedFeeds([]);
  }

  const showMoreButton = () => {
    if (data) {
      return !hideShowMore;
    }
  };

  const handleFilterSelect = (name, value) => {
    const { start, end } = value || {};
    setFromDate(getDateFormat(start));
    setToDate(getDateFormat(end));
  };

  const handleImageZoom = (e, articleImages, index) => {
    const imageArray = [];
    Array.isArray(articleImages) && articleImages.length
      ? articleImages.forEach(({ media_link = EMPTY_STRING }) => {
          imageArray.push(media_link);
        })
      : imageArray.push(articleImages);
    setImageSrcArray(imageArray);
    setShowImgViewer(true);
    setFirstImageToShow(index);
  };

  const handleDateChange = (date, type) => {
    setSelectedFeedsGroup([]);
    setSelectedFeeds([]);
    const formattedDate = moment(date).format("MM/DD/YYYY");
    if (type === "start") {
      setFromDate(formattedDate);
    } else {
      setToDate(formattedDate);
    }
  };

  const mergePaginatedFeedsToCurrentList = (allFeeds, entityId, type) => {
    let modifiedList = [];
    blogsAndForumsFeedList.forEach((item) => {
      if (
        item.topic.id == entityId &&
        item.feeds &&
        item.feeds[0].channel_type == type
      ) {
        item.feeds = allFeeds;
      }
      modifiedList.push(item);
    });

    setBlogsAndForumsFeedList(modifiedList);
    isSelectAll &&
      type &&
      handleSelectedFeeds(isSelectAll, modifiedList, entityId, selectedType);
  };

  const handleSelectedFeeds = (
    selected,
    feedlist,
    entityId,
    type = selectedType,
    entityName
  ) => {
    let tempFeedsToShare = {};
    const currentSelectedFeedObjects = blogsAndForumsFeedList.map((item) => {
      if (item.topic.id === entityId) {
        return {
          ...item,
          feeds: feedlist,
        };
      } else {
        return {
          ...item,
        };
      }
    });
    const currentSelectedFeedObject = currentSelectedFeedObjects.find(
      (item) =>
        item.topic &&
        item.topic.id == entityId &&
        item.feeds &&
        item.feeds[0].channel_type == type
    );
    if (selected) {
      if (
        !currentSelectedFeedObject ||
        !Array.isArray(currentSelectedFeedObject.feeds)
      ) {
        tempFeedsToShare = [feedlist];
      } else {
        tempFeedsToShare = currentSelectedFeedObject.feeds.map((elm) => {
          let feed = {
            ...elm,
            topic_name: entityName,
            topicName: elm.page_details && elm.page_details.name,
            isBulkUpdate: selected,
          };
          let feedAvailable = selectedFeeds.filter((item) => item.id == elm.id);
          if (feedAvailable.length == 0) {
            return feed;
          }
        });
      }
      setSelectedFeeds([
        ...selectedFeeds,
        ...tempFeedsToShare.filter((item) => !!item),
      ]);
    } else {
      if (!Array.isArray(feedlist)) {
        setSelectedFeeds(selectedFeeds.filter((n) => n.id != feedlist.id));
      } else {
        let tempArr = [...selectedFeeds];
        feedlist.forEach((element) => {
          tempArr = tempArr.filter((n) => {
            if (n.id !== element.id) return n;
          });
        });
        setSelectedFeeds(tempArr);
      }
    }
  };

  const handleFeedGroupClick = (groupIdentifier) => {
    if (selectedFeedsGroup.indexOf(groupIdentifier) !== -1) {
      setSelectedFeedsGroup(
        selectedFeedsGroup.filter((g) => g !== groupIdentifier)
      );
    } else {
      setSelectedFeedsGroup([...selectedFeedsGroup, groupIdentifier]);
    }
  };

  const handleBulkUpdateSuccess = (
    bulkUpdatedSentiment,
    bulkUpdatedTheme,
    bulkUpdatedFavourite = undefined
  ) => {
    if (
      !bulkUpdatedTheme &&
      !bulkUpdatedSentiment &&
      bulkUpdatedFavourite == undefined
    ) {
      return;
    }
    setUpdatedBulkSentiment(bulkUpdatedSentiment);
    if (bulkUpdatedFavourite != undefined) {
      setUpdatedBulkFavourite(bulkUpdatedFavourite);
    }
  };

  const formatFeedsForSentimentBulkUpdate = (array) => {
    const listGroupedByEntities = groupBy(array, "entityId");
    let formattedList = [];
    for (const entityKey in listGroupedByEntities) {
      if (Object.hasOwnProperty.call(listGroupedByEntities, entityKey)) {
        const listByEntity = listGroupedByEntities[entityKey];
        const groupedByType = groupBy(listByEntity, "type");
        for (const typeKey in groupedByType) {
          if (Object.hasOwnProperty.call(groupedByType, typeKey)) {
            const listByType = groupedByType[typeKey];
            formattedList.push({
              type: typeKey,
              entity: entityKey,
              feeds: listByType,
            });
          }
        }
      }
    }
    return formattedList;
  };

  const formatTagsForBulkUpdate = (tagList, selectedFeedsList) => {
    let updateByFilter = false;
    let tempFeedArray = [];
    selectedFeedsList.forEach((item) => {
      if (item.isBulkUpdate) {
        updateByFilter = item.isBulkUpdate;
      }
      tempFeedArray.push({
        social_feed_id: item.id,
        channel_type: item.channel_type,
      });
    });
    return {
      updateByFilter,
      tag_ids: tagList.map((i) => i.id),
      feeds: tempFeedArray,
    };
  };

  const handleTagsBulkUpdate = (selectedTags) => {
    const formattedList = formatFeedsForSentimentBulkUpdate(selectedFeeds);
    let promiseList = [];
    formattedList.forEach((item) => {
      const payload = formatTagsForBulkUpdate(selectedTags, item.feeds);
      const currentEntity = [item.entity];
      const currentverticalType = item.type;
      promiseList = [
        ...promiseList,
        httpPost(
          getFeedSearchUrl(currentEntity, currentverticalType, "tags"),
          payload
        ),
      ];
    });

    return Promise.allSettled(promiseList)
      .then((res) => {
        setSelectedFeeds([]);
        setSelectedFeedsGroup([]);
        updateSelectedTagsToFeeds(
          selectedTags.map((item) => {
            return {
              tag_id: item.tag_id || item.id,
              tag_name: item.name,
            };
          })
        );
        setShowAddTagListModal(false);
      })
      .catch((err) => {
        console.log(err);
        alert("Couldn't add tags");
      });
  };

  const updateSelectedTagsToFeeds = (
    selectedTags,
    removeTagFromList = false,
    entityId,
    feedId
  ) => {
    let modifiedFeeds = [];
    blogsAndForumsFeedList.forEach((feed) => {
      if (removeTagFromList) {
        if (feed.topic.id == entityId) {
          feed.feeds.forEach((feedItem) => {
            if (feedItem.id == feedId) {
              feedItem.tags = filterListFromAnotherList(
                feedItem.tags,
                selectedTags,
                "tag_id"
              );
            }
          });
        }
      } else {
        selectedFeeds.forEach((item) => {
          if (feed.topic.id == item.entityId) {
            feed.feeds.forEach((feedItem) => {
              if (item.id == feedItem.id) {
                feedItem.tags = getUniqueValuesFromList(
                  [...feedItem.tags, ...selectedTags],
                  "tag_id"
                );
              }
            });
          }
        });
      }
      modifiedFeeds.push(feed);
    });
    setBlogsAndForumsFeedList(modifiedFeeds);
  };

  const resetSelectedFeeds = () => {
    setSelectedFeeds([]);
    setSelectedFeedsGroup([]);
  };

  const showLoader = isLoading;
  const showNoDataMessage = !showLoader && !blogsAndForumsFeedList.length;
  const showData = !showLoader && !showNoDataMessage;
  const progressPopup = (open) => {
    setShowList(open);
  };
  const isDownloading =
    isPrintDownloading == "true" ||
    isSocialDownloading == "true" ||
    isBlogDownloading == "true";

  return (
    <>
      {showAddTagListModal ? (
        <TagsListModal
          show={showAddTagListModal}
          onCancel={() => setShowAddTagListModal(false)}
          onBulkUpdate={handleTagsBulkUpdate}
        />
      ) : null}
      <div
        className={
          !!selectedFeeds.length
            ? "mainContainer socialContainer blogsForumContainer feedsSelected"
            : "mainContainer socialContainer blogsForumContainer"
        }
      >
        {showLoader && <GifLoader />}
        <div className="dashboardHeader dashboardHeading">
          <div className="dashboardHeaderTop d-flex">
            <div className="dashboardMobileMenu">
              <button className="btn menuBtn" id="menuBtn">
                <MenuIcon />
              </button>
              <img src={ConceptLogo} width="32" height="32" />
            </div>
            <div className="dhLeft d-flex">
              <div className="dhLeftWrap d-flex align-items-center">
                <h1>Blogs and Forum</h1>
              </div>
              {popup && (
                <div className={styles.downloadLabel}>
                  <DownLoadSuccess />
                  <h3>Report download completed successfully !</h3>
                </div>
              )}
            </div>
          </div>
          <div className="topFilterWrap">
            <div className="mobTopHeading">
              <h1>Blogs and Forum</h1>
            </div>
            <div className="titleRow blogsForumTitleRow">
              <div className="titleLeftWrap">
                <div className="filterWrap">
                  <DateRangeFilter
                    key="social-feed"
                    startRange={fromDate}
                    endRange={toDate}
                    handleDateChange={handleDateChange}
                    showShortCut
                    minDate={selectedClient ? selectedClient.start_date : null}
                    maxDate={selectedClient ? selectedClient.end_date : null}
                  />
                  {/* <DateRangeFilter /> */}
                  <div className="downloadBtnWithText singleDownloadBtn">
                    <SocialDownload
                      articles={selectedFeeds}
                      downloadUrl={getFeedSearchUrl([], "", "olddownload")}
                      onSuccessCallback={resetSelectedFeeds}
                      totalFeedCount={totalFeedCount}
                      setIsLoading={setIsLoad}
                      isLoading={isLoad}
                      IsBlogs
                    />
                  </div>
                  <button
                    onClick={() => setShowFilter(true)}
                    className="btn filterBtn"
                  >
                    <FilterIcon /> <span>Filters</span>
                  </button>
                </div>
              </div>
              <div className="rightBtnContainer">
                <ul className="dropDownContainer">
                  {selectedFeeds && !!selectedFeeds.length && (
                    <ArticleTags
                      article={selectedFeeds}
                      forBulkUpdate
                      getFeedSearchUrl={getFeedSearchUrl}
                      isBlogAndForum
                      hideTheme
                      onSuccessCallback={handleBulkUpdateSuccess}
                      setUpdatedBulkFavourite={setUpdatedBulkFavourite}
                      setUpdatedBulkSentiment={setUpdatedBulkSentiment}
                      showFavouriteTag
                      singleNewsGroup={selectedFeeds}
                    />
                  )}
                  {selectedFeeds && !!selectedFeeds.length && (
                    <button
                      className="btn addTagBtn"
                      onClick={() => setShowAddTagListModal(true)}
                    >
                      <PlusIcon /> Add Tag
                    </button>
                  )}
                  <div className="downloadBtnWithText singleDownloadBtn">
                    <SocialDownload
                      articles={selectedFeeds}
                      downloadUrl={getFeedSearchUrl([], "", "olddownload")}
                      onSuccessCallback={resetSelectedFeeds}
                      totalFeedCount={totalFeedCount}
                      setIsLoading={setIsLoad}
                      isLoading={isLoad}
                      IsBlogs
                    />
                  </div>
                  {isDownloading && !isLoad && (
                    <div className={styles.DownloadPopup_downloadList__3zmI8}>
                      <DownloadPopup
                        IsPrintAndOnline={isPrintDownloading === "true"}
                        clicked={progressPopup}
                        showList={showList}
                        IsBlogAndForum={isBlogDownloading === "true"}
                        isSocial={isSocialDownloading === "true"}
                      />
                    </div>
                  )}
                  <button
                    onClick={() => setShowFilter(true)}
                    className="btn filterBtn"
                  >
                    <FilterIcon /> <span>Filters</span>
                  </button>
                </ul>
                <div
                  className={`filtersWrap sideFilterWrap ${
                    !showFilter ? "hide" : "show"
                  }`}
                >
                  <div className="filtersColumnWrap">
                    {/* <Filters /> */}
                    <SocialFilters
                      handleFilterSelect={handleFilterSelect}
                      fetchSocialFeeds={onFilterApply}
                      cityData={city}
                      setTonality={setTonality}
                      fromDate={fromDate}
                      toDate={toDate}
                      tonality={tonality}
                      detailsField={detailsFeed}
                      selectCity={selectCity}
                      setSelectedCity={setSelectedCity}
                      comments={comments}
                      setComments={setComments}
                      channelType={channelType}
                      setChannelType={setChannelType}
                      reaction={reaction}
                      setReaction={setReaction}
                      handleResetAll={handleResetAll}
                      setShowFilter={setShowFilter}
                      setSelectedTopics={setSelectedTopics}
                      selectedTopics={selectedTopics}
                      entityList={socialEntityList}
                      isBlogAndForum
                      isFavouriteChecked={isFavouriteChecked}
                      setIsFavouriteChecked={setIsFavouriteChecked}
                      vertical={vertical}
                      setVertical={setVertical}
                      tagList={tagListData}
                      setSelectedTaglist={setSelectedTaglist}
                      selectedTaglist={selectedTaglist}
                      headline={headline}
                      setHeadline={setHeadline}
                      keyword={keyword}
                      setKeyword={setKeyword}
                      // tagsApplied={tagsApplied}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showData && totalFeedCount && (
          <div
            style={{
              color: "#0036b9",
              marginTop: "5px",
              marginBottom: "5px",
              fontSize: "14px",
            }}
          >
            {fromDate == toDate && (
              <>
                Total <span className="feed-count-info">{totalFeedCount}</span>{" "}
                articles found on{" "}
                <span className="feed-count-info">
                  {moment(fromDate).format("Do MMMM YYYY")}
                </span>
              </>
            )}
            {fromDate != toDate && (
              <>
                Total <span className="feed-count-info">{totalFeedCount}</span>{" "}
                articles were found from{" "}
                <span className="feed-count-info">
                  {moment(fromDate).format("Do MMMM YYYY")}
                </span>{" "}
                to{" "}
                <span className="feed-count-info">
                  {moment(toDate).format("Do MMMM YYYY")}
                </span>
              </>
            )}
          </div>
        )}
        {showData && (
          <div
            ref={listContainerRef}
            className="accordion accordionListWrap blogsForumsAccordionWrap"
          >
            {blogsAndForumsFeedList.map((singleFeedGroup, index) => {
              const data = {
                entityName: singleFeedGroup.topic.name,
                blogsAndForumData: [],
                type: singleFeedGroup.type || 5,
                entityId: singleFeedGroup.topic.id,
                total: singleFeedGroup.count,
              };
              // const allArticleList = singleFeedGroup.feeds.map(
              //   (e) =>
              //     `${e.channel_type}/${e.id}?entityName="${singleFeedGroup.topic.name}"`
              // );
              const allArticleList = [];
              return (
                <TopicWiseNewsContainer
                  key={index + 1}
                  listContainerRef={listContainerRef}
                  listkey={index + 1}
                  entityFeeds={data}
                  activeKey={activeKey}
                  setActiveKey={setActiveKey}
                  allArticleList={allArticleList}
                  onFeedSelect={handleSelectedFeeds}
                  selectedFeeds={selectedFeeds}
                  selectedFeedsGroup={selectedFeedsGroup}
                  setSelectedFeedsGroup={setSelectedFeedsGroup}
                  handleFeedGroupClick={handleFeedGroupClick}
                  onSuccessCallback={handleBulkUpdateSuccess}
                  updatedBulkSentiment={updatedBulkSentiment}
                  updatedBulkFavourite={updatedBulkFavourite}
                  isBlogsAndForum
                  toDate={toDate}
                  fromDate={fromDate}
                  clientId={selectedClient.id}
                  updateSelectedTagsToFeeds={updateSelectedTagsToFeeds}
                  mergePaginatedFeedsToCurrentList={
                    mergePaginatedFeedsToCurrentList
                  }
                  setIsSelectAll={setIsSelectAll}
                  setSelectedType={setSelectedType}
                  socialFilters={{
                    selectedTopics,
                    isFavouriteChecked,
                    selectedTaglist,
                    keyword,
                    headline,
                  }}
                  // tagsApplied={tagsApplied}
                />
              );
            })}
          </div>
        )}
        {showNoDataMessage && (
          <NoDataMessage
            text="No Feeds Found"
            subtext="Try adjusting the filters to find what you’re looking for"
          />
        )}
      </div>
    </>
  );
}

export default BlogsAndForum;
